import { routePaths } from '@screens/routes';
import { matchPath } from 'react-router';

export interface DashboardNavigationState {
  readonly dashboardOrganizationId?: string;
  readonly dashboardWorkspaceId: string;
}

/** Navigation context is scoped to its workspace and never becomes a portfolio filter. */
export function getDashboardOrganizationId(pathname: string, state: unknown): string | undefined {
  const workspace = matchPath(routePaths.workspaceDashboard, pathname)?.params.workspaceId;
  if (!workspace || !state || typeof state !== 'object') return undefined;
  if (
    'dashboardWorkspaceId' in state &&
    state.dashboardWorkspaceId === workspace &&
    'dashboardOrganizationId' in state &&
    typeof state.dashboardOrganizationId === 'string'
  ) {
    return state.dashboardOrganizationId;
  }
  return undefined;
}

export function getGuideOrganizationId(pathname: string, state: unknown): string | undefined {
  return (
    matchPath({ path: routePaths.properties, end: false }, pathname)?.params.organizationId ??
    matchPath('/app/organizations/workspace/:workspaceId/organization/:organizationId/*', pathname)
      ?.params.organizationId ??
    getDashboardOrganizationId(pathname, state)
  );
}
